import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SvcHttpClient } from 'projects/lib-shared-common/src/lib/classes/svc-http-client';
import { AppEnvironmentConfig } from 'projects/config/model/environment.config.model';

@Injectable({ providedIn: 'root' })
export class AdministrationHttpClient extends SvcHttpClient {
  constructor(appConfig: AppEnvironmentConfig, httpClient: HttpClient) {
    super(appConfig.APIs.apiUrlAdministration, httpClient);
  }
}
